import api from '../utils/api';

// ========== MÉTHODES POUR ADMIN/MANAGER/SALES_REP ==========

// ✅ Lister toutes les factures
export const getAllInvoices = async () => {
    try {
        const response = await api.get('/invoices');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoices');
    }
};

// ✅ Obtenir une facture par ID
export const getInvoiceById = async (id) => {
    try {
        const response = await api.get(`/invoices/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoice');
    }
};

// ✅ Obtenir les factures par statut
export const getInvoicesByStatus = async (status) => {
    try {
        const response = await api.get(`/invoices/status/${status}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoices by status');
    }
};

// ✅ Lister les factures en retard
export const getOverdueInvoices = async () => {
    try {
        const response = await api.get('/invoices/overdue');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch overdue invoices');
    }
};

// ========== NOUVELLES MÉTHODES POUR DISTRIBUTEUR ==========

// ✅ Lister toutes les factures du distributeur connecté
export const getMyInvoices = async () => {
    try {
        const response = await api.get('/invoices/my-invoices');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch my invoices');
    }
};

// ✅ Obtenir les factures du distributeur par statut
export const getMyInvoicesByStatus = async (status) => {
    try {
        const response = await api.get(`/invoices/my-invoices/status/${status}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch my invoices by status');
    }
};

// ✅ Lister les factures en retard du distributeur
export const getMyOverdueInvoices = async () => {
    try {
        const response = await api.get('/invoices/my-invoices/overdue');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch my overdue invoices');
    }
};

// ✅ Montant total en attente du distributeur
export const getMyTotalPendingAmount = async () => {
    try {
        const response = await api.get('/invoices/my-invoices/statistics/pending-amount');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch my pending amount');
    }
};

// ========== MÉTHODES COMMUNES ==========

// ✅ Créer une nouvelle facture
export const createInvoice = async (invoiceData) => {
    try {
        const response = await api.post('/invoices', invoiceData);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to create invoice');
    }
};

// ✅ Mettre à jour une facture
export const updateInvoice = async (id, invoiceData) => {
    try {
        const response = await api.put(`/invoices/${id}`, invoiceData);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to update invoice');
    }
};

// ✅ Supprimer une facture
export const deleteInvoice = async (id) => {
    try {
        const response = await api.delete(`/invoices/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to delete invoice');
    }
};

// ✅ Enregistrer un paiement
export const recordPayment = async (id) => {
    try {
        const response = await api.post(`/invoices/${id}/payment`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to record payment');
    }
};

// ✅ Montant total en attente de paiement (Admin/Manager)
export const getTotalPendingAmount = async () => {
    try {
        const response = await api.get('/invoices/statistics/pending-amount');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch pending amount');
    }
};

// ✅ Montant total payé dans une période (Admin/Manager)
export const getTotalPaidInPeriod = async (startDate, endDate) => {
    try {
        const response = await api.get('/invoices/statistics/paid-in-period', {
            params: { startDate, endDate }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch total paid in period');
    }
};